<template>
  <div class="dashboard-pages">
    <v-card px-4 pb-4 pr-5>
      <v-layout style="width: 70%; margin: auto">
        <v-tabs v-model="active">
          <v-tab v-for="(n, index) in tabSections" :key="index">
            {{ n.text }}
          </v-tab>
          <v-tab-item>
            <v-card flat>
              <v-card-text style="padding: 0px; padding-top: 20px">
                <form @submit.prevent="validateBeforeSubmit($event)">
                  <v-card-title style="padding: 0px">
                    <v-layout column>
                      <v-layout row wrap>
                        <v-flex xs12 sm4 md3>
                          <v-layout row wrap justify-content-start style="margin:0 auto; max-width:200px;">
                            <v-flex xs12>
                              <label @click="chooseImage" style="cursor:pointer">
                                <v-hover>
                                  <v-card slot-scope="{ hover }" flat color="grey lighten-4" max-width="600">
                                    <div
                                      class="user-profile-image"
                                      :style="{
                                        'background-image': `url(${imageData})`
                                      }"
                                    >
                                      <span v-if="!imageData" class="placeholder">
                                        <v-img
                                          :src="
                                            authUserData.user_image_path === null ||
                                            authUserData.user_image_path === undefined ||
                                            authUserData.user_image_path === ''
                                              ? `${baseUrls.images}/${
                                                  authUserData.theGender === 'Female'
                                                    ? 'profile-female.png'
                                                    : 'profile-male.png'
                                                }`
                                              : `${baseUrls.images}/${authUserData.user_image_path}`
                                          "
                                          height="230"
                                        />
                                      </span>
                                      <v-expand-transition>
                                        <div
                                          v-if="hover"
                                          class="transition-fast-in-fast-out v-card--reveal white--text headline image-upload-overlay"
                                        >
                                          <div class="overlay-inner-content">
                                            {{ $t('Click To Upload') }}
                                          </div>
                                        </div>
                                      </v-expand-transition>
                                    </div>
                                  </v-card>
                                </v-hover>
                              </label>
                            </v-flex>
                            <input
                              type="file"
                              name="user_image_path"
                              ref="fileInput"
                              style="visibility:hidden; width:0; position:absolute; top:-9999px"
                              v-validate="'size:2047|ext:jpeg,jpg,png'"
                              @input="onSelectFile"
                            />
                            <label
                              style="pointer-events: none; font-weight: bold; font-size: 16px; width: 200px; text-align: center"
                              >{{ authUserData.user_full_name }}</label
                            >
                          </v-layout>
                        </v-flex>

                        <v-flex xs12 sm8 md9>
                          <v-layout row wrap justify-content-end>
                            <v-flex xs12 class="px-2">
                              <v-text-field
                                v-model="authUserData.email"
                                :label="`${$t('Email')} *`"
                                name="email"
                                box
                                hide-details
                                background-color="gray"
                                autocomplete="off"
                                :error="errors.has('email')"
                                v-validate="'required|email'"
                                data-vv-validate-on="blur"
                              />
                            </v-flex>

                            <v-flex xs6 sm4 pt-3 class="pa-2">
                              <v-text-field
                                v-model="authUserData.user_phone"
                                :label="$t('Phone')"
                                name="user_phone"
                                box
                                hide-details
                                background-color="gray"
                                :error="errors.has('user_phone')"
                              />
                            </v-flex>

                            <v-flex xs6 sm4 pt-3 class="pa-2">
                              <v-autocomplete
                                v-model="authUserData.user_gender"
                                :items="genderList"
                                :label="$t('Gender')"
                                box
                                hide-details
                                background-color="gray"
                                :error="errors.has('user_gender')"
                                data-vv-name="user_gender"
                                :menu-props="{
                                  transition: 'slide-y-transition'
                                }"
                              />
                            </v-flex>

                            <v-flex xs6 sm4 pt-3 class="pa-2">
                              <v-menu
                                v-model="birthDateMenu"
                                full-width
                                max-width="290"
                                :close-on-content-click="false"
                              >
                                <v-text-field
                                  slot="activator"
                                  :value="authUserData.user_dob"
                                  :label="$t('Birth Date')"
                                  name="user_dob"
                                  prepend-inner-icon="event"
                                  box
                                  readonly
                                  hide-details
                                  background-color="gray"
                                  autocomplete="off"
                                  :error="errors.has('user_dob')"
                                  v-validate="'date_format:yyyy-MM-dd'"
                                />
                                <v-date-picker @change="birthDateMenu = false" v-model="authUserData.user_dob" />
                              </v-menu>
                            </v-flex>

                            <v-flex pt-3 xs6 sm4 class="pa-2">
                              <v-autocomplete
                                v-model="authUserData.user_blood_group"
                                :items="bloodGroupsList"
                                :label="$t('Blood Group')"
                                box
                                hide-details
                                background-color="gray"
                                :error="errors.has('user_blood_group')"
                                data-vv-name="user_blood_group"
                                :menu-props="{
                                  transition: 'slide-y-transition'
                                }"
                              />
                            </v-flex>

                            <v-flex pt-3 xs6 sm4 class="pa-2">
                              <v-autocomplete
                                v-model="authUserData.user_marital_status"
                                :items="maritalStatusList"
                                :label="$t('Marital Status')"
                                box
                                hide-details
                                background-color="gray"
                                class="text-capitalize"
                                :error="errors.has('user_marital_status')"
                                data-vv-name="user_marital_status"
                                :menu-props="{
                                  transition: 'slide-y-transition'
                                }"
                              />
                            </v-flex>

                            <v-flex pt-3 xs6 sm4 class="pa-2">
                              <v-text-field
                                v-model="authUserData.user_nationality"
                                :label="$t('Nationality')"
                                name="user_nationality"
                                box
                                hide-details
                                background-color="gray"
                                :error="errors.has('user_nationality')"
                              />
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>

                      <v-layout wrap>
                        <v-flex xs12 class="py-2 px-1">
                          <v-textarea
                            v-model="authUserData.user_address"
                            :label="$t('Address')"
                            name="user_address"
                            box
                            hide-details
                            height="80"
                            background-color="gray"
                            :error="errors.has('user_address')"
                          />
                        </v-flex>
                        <v-flex xs12 class="py-2 px-1">
                          <v-autocomplete
                            v-model="authUserData.lang"
                            :items="localeList"
                            :label="$t('System Language')"
                            box
                            hide-details
                            background-color="gray"
                            :error="errors.has('System Language')"
                            data-vv-name="System Language"
                            :menu-props="{ transition: 'slide-y-transition' }"
                          />
                        </v-flex>
                      </v-layout>
                    </v-layout>
                  </v-card-title>

                  <v-divider light />

                  <v-card-actions>
                    <v-layout column>
                      <v-flex xs12 class="pb-2 px-2" style="color: #444;">
                        -
                        {{ $t('Fields marked with asterisk ( * ) are required.') }}
                      </v-flex>

                      <v-layout justify-end ma-2>
                        <v-btn type="submit" color="success" :loading="btnUpdateLoading">
                          <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">save</v-icon>
                          {{ $t('Update') }}
                        </v-btn>
                      </v-layout>
                    </v-layout>
                  </v-card-actions>
                </form>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card flat>
              <v-card-text style="padding: 0px; padding-top: 20px">
                <change-user-password />
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item v-if="hasPermissions(['outlet_select'])">
            <v-card flat>
              <v-card-text style="padding: 0px; padding-top: 20px;">
                <switch-user-outlet />
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import * as helpers from '@/mixins/helperFunctions.js'

export default {
  name: 'profile',

  components: {
    changeUserPassword: () => import('./changeUserPassword.vue'),
    switchUserOutlet: () => import('./switchUserOutlet.vue')
  },

  data() {
    return {
      active: null,
      btnUpdateLoading: false,
      birthDateMenu: false,
      imageData: null,
      imageInput: null,
      form: {},
      imageFile: null,
      tabSections: [{ text: `${this.$t('Update profile')}` }, { text: `${this.$t('Change password')}` }]
    }
  },

  mounted() {
    this.setAppBarTitle({
      title: this.$t('Profile'),
      icon: 'fa-user'
    })

    if (this.hasPermissions(['outlet_select'])) {
      this.tabSections.push({ text: `${this.$t('Switch Outlet')}` })
    }
  },

  computed: {
    ...mapGetters({
      authUserData: 'auth/getAuthUserData',
      baseUrls: 'misc/getBaseUrls',
      genderList: 'staff/getGenderList',
      bloodGroupsList: 'staff/getBloodGroupsList',
      maritalStatusList: 'staff/getMaritalStatusList',
      localeList: 'locale/getLocales'
    })
  },

  methods: {
    ...mapActions({
      updateStaffMemberInfo: 'staff/updateStaffProfileInfo',
      setRtl: 'locale/setRtl',
      setCountriesList: 'locale/setCountriesList'
    }),

    hasPermissions(permissions) {
      return helpers.userHasPermissions(permissions)
    },

    chooseImage() {
      this.$refs.fileInput.click()
    },

    onSelectFile() {
      this.imageInput = this.$refs.fileInput
      this.imageFile = this.imageInput.files

      if (this.imageFile && this.imageFile[0]) {
        const reader = new FileReader()
        reader.onload = e => {
          this.imageData = e.target.result
        }
        reader.readAsDataURL(this.imageFile[0])
        this.$emit('input', this.imageFile[0])
      }
    },

    changeLanguage(lang) {
      // filter the available locales array for a matching value of the lang and get the first match
      let isRtl = false
      let direction = this.localeList.filter(l => l.value === lang)[0]

      // if no match then default to english, same for "dir" property default to "ltr" if not defined
      // or not "rtl"
      if (!direction) {
        lang = 'en'
      } else {
        isRtl = !!(direction.dir === 'rtl')
      }

      localStorage.setItem('language', lang)
      this.$vuetify.rtl = isRtl
      this.$i18n.locale = lang
      this.setCountriesList(lang)
      this.setRtl(isRtl)
    },

    validateBeforeSubmit(event) {
      this.$validator
        .validateAll()
        .then(() => {
          if (!this.errors.any()) {
            this.btnUpdateLoading = true
            let formData = new FormData(event.target)
            formData.append('user_gender', this.authUserData.user_gender || '')
            formData.append('user_blood_group', this.authUserData.user_blood_group || '')
            formData.append('user_marital_status', this.authUserData.user_marital_status || '')
            formData.append('outlet_id_fk', this.authUserData.outlet_id_fk)
            formData.append('lang', this.authUserData.lang)
            formData.set('user_dob', this.authUserData.user_dob || '')
            formData.append('user_full_name', this.authUserData.user_full_name)
            if (this.imageData != null) {
              formData.append('user_image_path', this.imageFile[0])
            }

            this.updateStaffMemberInfo(formData)
              .then(() => {
                this.changeLanguage(this.authUserData.lang)
                this.btnUpdateLoading = false
              })
              .then(() => {
                window.location.reload()
              })
              .catch(() => {
                this.btnUpdateLoading = false
              })
          }
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
}
</script>

<style scoped>
.user-profile-image {
  display: block;
  width: 100%;
  height: 230px;
  cursor: pointer;
  background-size: cover;
  background-position: center center;
}
</style>
